import Layout from "../layouts/LayoutDefault.jsx";
import React, { useState, useEffect } from "react";
import MainContainer from "../components/MainContainer";
import ContentContainer from "../components/ContentContainer";

const adsAboutPage = () => {
  const apiUrl = import.meta.env.VITE_API_URL_TEXTS;

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(apiUrl + "lokultinfo");

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();
        setData(result);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error}</p>;

  return (
    <Layout
      title="Synas på Lokult"
      description="Om att bli partner och marknadsföra sig på Lokult"
    >
      <MainContainer>
        <ContentContainer>
          <div className="m-auto my-20">
            {data ? (
              <div
                className="prose lg:prose-xl"
                dangerouslySetInnerHTML={{ __html: data.data.ads }}
              />
            ) : (
              <p>No data available.</p>
            )}
          </div>
        </ContentContainer>
      </MainContainer>
    </Layout>
  );
};

export default adsAboutPage;
